(() => {
	angular.module('main').directive('btnAddFile', btnAddFile);

	btnAddFile.$inject = [];

	function btnAddFile() {
		return {
			restrict: 'E',
			transclude: true,
			scope: {
				isActive: '=isActive',
				files: '=',
				imageClass: '@',
				saveFiles: '&'
			},
			template() {
				const template = `<div class="add-file-wrapper {{imageClass}} spinning-wheel spinning-wheel__display-after">
                                    <input type="file" name="file" id="file-upload" class="input-file" file-upload="files" save-files="saveFiles({item:item, jobId:jobId})"  />
                                    <label class="btn btn-add-round btn-success' ng-scope ng-isolate-scope" for="file-upload"></label>
                                </div>`;

				return template;
			},
			replace: true,
			link(scope, element) {
				toggleSpinningWheel();

				scope.$watch('isActive', () => {
					toggleSpinningWheel();
				});

				function toggleSpinningWheel() {
					if (scope.isActive && !element.hasClass('spinning-wheel__active')) {
						element.addClass('spinning-wheel__active');
					} else {
						element.removeClass('spinning-wheel__active');
					}
				}
			}
		};
	}
})();

(() => {
	angular.module('main').directive('fileUpload', fileUpload);

	fileUpload.$inject = [
		'$parse',
		'$rootScope',
		'$routeParams',
		'messageService'
	];

	function fileUpload($parse, $rootScope, $routeParams, messageService) {
		return {
			restrict: 'A',
			scope: {
				saveFiles: '&'
			},
			link(scope, element, attrs) {
				const model = $parse(attrs.fileUpload);
				const modelSetter = model.assign;

				element.bind('change', () => {
					const values = [];
					const maxMb = 20; // 20 Mb
					const maxSize = maxMb * 1000 * 1024;

					angular.forEach(element[0].files, item => {
						if (item.size <= maxSize) {
							values.push(item);

							const tmpDate = new Date(item.lastModifiedDate);
							const monthNames = [
								'January',
								'February',
								'March',
								'April',
								'May',
								'June',
								'July',
								'August',
								'September',
								'October',
								'November',
								'December'
							];
							item.customLastModifiedDate = `${tmpDate.getDate()} ${
								monthNames[tmpDate.getMonth()]
							} ${tmpDate.getFullYear()}`;

							item.convertedSize = (
								parseInt(item.size) /
								(1024 * 1024)
							).toFixed(2); // convert from bytes to MB

							const jobId = $routeParams.jobId;

							scope.saveFiles({ item, jobId });

							element[0].value = null;

							if (!$rootScope.$$phase) {
								$rootScope.$apply();
							}
						} else {
							messageService.showToaster('w_1', 'attachments');
							element[0].value = null;
						}
					});

					scope.$apply(() => {
						modelSetter(scope, values[0]);
					});
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnAddFile.js